import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { TabView, TabPanel } from 'primereact/tabview';
import CandidatesBackButton from '../../../CandidateDetails/BackButton/CandidatesBackButton';
import classes from './AdditionalVideosInternal.module.css';
import {
  VideoSection,
  VideoGalleryFull,
  ActiveVideoModal,
} from '../components';

import SmartInterviewsVideosList from '../components/VideoGalleryFull/SmartInterviewsVideosList/SmartInterviewsVideosList';

const AdditionalVideosInternalScreen = ({
  hideBackButton,
}: {
  hideBackButton?: boolean;
}) => {
  const navigate = useNavigate();
  const [t] = useTranslation('global');
  const { candidateId } = useParams();
  return (
    <section className={classes.layout}>
      {!hideBackButton && (
        <>
          <CandidatesBackButton
            text={`${t('AdditionalVideos.backButton')}`}
            onClick={() =>
              navigate(`/simera-dashboard/candidates/${candidateId}`, {
                replace: true,
              })
            }
            isSecondary
          />
          <br />
        </>
      )}
      <VideoSection>
        <TabView>
          <TabPanel header={t('AdditionalVideos.galleryTitleInternal')}>
            <VideoGalleryFull internal />
          </TabPanel>
          <TabPanel header={t('AdditionalVideos.smartInterview.title')}>
            <SmartInterviewsVideosList />
          </TabPanel>
        </TabView>
      </VideoSection>
      <ActiveVideoModal internal />
    </section>
  );
};

AdditionalVideosInternalScreen.defaultProps = {
  hideBackButton: false,
};

export default AdditionalVideosInternalScreen;
